import { useParams, useOutlet } from 'react-router-dom';
import { Conversations } from '../pages/Conversations';

export const ConversationLayout = () => {
  const { id } = useParams<{ id: string }>();
  const outlet = useOutlet();

  return (
    <div className="relative flex-1 -m-5 lg:-m-6">
      <div className="absolute inset-0 flex overflow-hidden">

        {/* Left panel — always visible on desktop, hidden on mobile when chat is open */}
        <div className={`flex flex-col w-full md:w-[340px] md:min-w-[300px] border-r border-gray-100 md:flex-shrink-0 overflow-hidden ${id ? 'hidden md:flex' : 'flex'}`}>
          <Conversations />
        </div>

        {/* Right panel — placeholder or ConversationShow */}
        <div className={`flex-1 flex flex-col min-w-0 overflow-hidden ${id ? 'flex' : 'hidden md:flex'}`}>
          {outlet ?? (
            <div className="flex-1 flex items-center justify-center text-secondary-400 text-sm select-none">
              Click any conversation to open the chat
            </div>
          )}
        </div>

      </div>
    </div>
  );
};
